import React from 'react';
import { motion } from 'framer-motion';
import { BUSINESS_STAGES, BUSINESS_STAGE_COLORS } from '../../constants/businessStages';

const StageSelector = ({ value, onChange, label = 'Business Stage', disabled = false }) => {
  const current = BUSINESS_STAGE_COLORS[value] || {
    bg: 'bg-gray-50',
    text: 'text-gray-700',
    ring: 'ring-gray-200',
  };

  return (
    <div className="space-y-2">
      <label className="text-sm font-medium text-gray-700">{label}</label>

      <select
        value={value || ''}
        onChange={e => onChange?.(e.target.value)}
        disabled={disabled}
        className="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-700 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500 disabled:cursor-not-allowed disabled:bg-gray-100"
      >
        <option value="">Select Business Stage</option>
        {BUSINESS_STAGES.map(stage => {
          const c = BUSINESS_STAGE_COLORS[stage];
          return (
            <option key={stage} value={stage}>
              {stage}
            </option>
          );
        })}
      </select>

      <div className="grid grid-cols-1 gap-2 sm:grid-cols-2 lg:grid-cols-3">
        {BUSINESS_STAGES.map(stage => {
          const c = BUSINESS_STAGE_COLORS[stage];
          const selected = value === stage;
          return (
            <motion.button
              key={stage}
              type="button"
              whileHover={{ scale: disabled ? 1 : 1.01 }}
              whileTap={{ scale: disabled ? 1 : 0.99 }}
              onClick={() => !disabled && onChange?.(stage)}
              className={`flex items-center justify-between rounded-lg border px-3 py-2 text-sm ${
                selected
                  ? `${c.bg} ${c.text} border-transparent ring-2 ${c.ring}`
                  : 'border-gray-200 bg-white text-gray-700 hover:border-gray-300'
              } ${disabled ? 'cursor-not-allowed opacity-60' : ''}`}
              aria-pressed={selected}
            >
              <span>{stage}</span>
              {selected && (
                <span className="ml-2 rounded-full bg-black/10 px-2 py-0.5 text-xs text-black/70">
                  Current
                </span>
              )}
            </motion.button>
          );
        })}
      </div>
      <div className="sr-only">
        <select value={value || ''} onChange={e => onChange?.(e.target.value)} disabled={disabled}>
          <option value="">Select stage</option>
          {BUSINESS_STAGES.map(s => (
            <option key={s} value={s}>
              {s}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default StageSelector;
